import $ from 'jquery';
import dateformat from 'dateformat';
import Grid from './grid';
import Menu from './menu';

const GRID_CONTEXT_MENU = Menu.normalize([
  {divider: true},
  {text: 'Export to Excel', attr: {id: 'export-to-excel'}}
]);
const REGEXPS = {
  CHI_LINK: /http:\/\/127\.0\.0\.1\/\?send=([^<#]+)(<cr>)?/i,
  DASH: /-/g,
  DATEISH: /^\d?\d[/-]\d?\d[/-]\d\d(?:\d\d)?$/,
  DIGITS: /^\d+$/,
  EXT_LINK: /^https?:\/\/[a-z]/i,
  NEWLINES: /\r?\n/g,
  IS_IT_TEXT: /[a-z].*[a-z]/i,
  SELECTABLE: /\b(row|cell)$/,
  SLASH: /\//g,
  TRAILING_UNDERSCORES: /_+$/,
  UNDERSCORE: /_/g
}
const WIN1252_TO_UTF8 = [
  '\u20ac', '', '\u201a', '\u0192', '\u201e', '\u2026', '\u2020', '\u2021',
  '\u02c6', '\u2030', '\u0160', '\u2039', '\u0152', '', '\u017d', '', '',
  '\u2018', '\u2019', '\u201c', '\u201d', '\u2022', '\u2013', '\u2014',
  '\u02dc', '\u2122', '\u0161', '\u203a', '\u0153', '', '\u017e', '\u0178',
  '\u00a0', '\u00a1', '\u00a2', '\u00a3', '\u00a4', '\u00a5', '\u00a6',
  '\u00a7', '\u00a8', '\u00a9', '\u00aa', '\u00ab', '\u00ac', '\u00ad',
  '\u00ae', '\u00af', '\u00b0', '\u00b1', '\u00b2', '\u00b3', '\u00b4',
  '\u00b5', '\u00b6', '\u00b7', '\u00b8', '\u00b9', '\u00ba', '\u00bb',
  '\u00bc', '\u00bd', '\u00be', '\u00bf', '\u00c0', '\u00c1', '\u00c2',
  '\u00c3', '\u00c4', '\u00c5', '\u00c6', '\u00c7', '\u00c8', '\u00c9',
  '\u00ca', '\u00cb', '\u00cc', '\u00cd', '\u00ce', '\u00cf', '\u00d0',
  '\u00d1', '\u00d2', '\u00d3', '\u00d4', '\u00d5', '\u00d6', '\u00d7',
  '\u00d8', '\u00d9', '\u00da', '\u00db', '\u00dc', '\u00dd', '\u00de',
  '\u00df', '\u00e0', '\u00e1', '\u00e2', '\u00e3', '\u00e4', '\u00e5',
  '\u00e6', '\u00e7', '\u00e8', '\u00e9', '\u00ea', '\u00eb', '\u00ec',
  '\u00ed', '\u00ee', '\u00ef', '\u00f0', '\u00f1', '\u00f2', '\u00f3',
  '\u00f4', '\u00f5', '\u00f6', '\u00f7', '\u00f8', '\u00f9', '\u00fa',
  '\u00fb', '\u00fc', '\u00fd', '\u00fe', '\u00ff'
];
function wms2skip() {
  console.debug('wms2skip', this);
  this.$root.$options.socket.emit('click', {id: 'wms0002namekeyword'});
}
function wms136apply(data) {
  console.debug('wms136apply', this, data);
  this.$root.$options.socket.emit('change', {
    id: 'wms0136namesearch',
    role: 'textfield',
    value: data.value
  });
  this.$root.$options.socket.emit('click', {id: 'wms0136find'});
}

const ACCT_BUTTONS = {
  'chi-demos-go': {
    field: 'chi-demos-pacct',
    button: 'chi-demos-search',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  'chi-demos-search': {
    field: 'chi-demos-pacct',
    button: 'chi-demos-search',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'ggo': {
  //  field: 'ggacct',
  //  button: 'gsearchgacct',
  //},
  'go': {
    field: 'wrf-pacct',
    button: 'patient_search',
    form: 'wae0006',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'gsearchgacct': {
  //  field: 'ggacct',
  //  button: 'gsearchgacct'
  //},
  'igo': {
    field: 'ipacct',
    button: 'isearchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  'isearchpacct': {
    field: 'ipacct',
    button: 'isearchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  'patient_search': {
    field: 'wrf-pacct',
    button: 'patient_search',
    form: 'wae0006',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  'pgo': {
    field: 'ppacct',
    button: 'psearchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'psearchgacct': {
  //  field: 'pgacct',
  //  button: 'psearchgacct'
  //},
  'psearchpacct': {
    field: 'ppacct',
    button: 'psearchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  'searchpacct': {
    field: 'pacct',
    button: 'searchpacct',
    form: 'wme0004',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  'wme0006searchpacct': {
    field: 'wme0006pacct',
    button: 'wme0006searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'wme0008cgo': {
  //  field: 'wme0008cacct',
  //  button: 'wme0008csearchgacct'
  //},
  //'wme0008csearchgacct': {
  //  field: 'wme0008cacct',
  //  button: 'wme0008csearchgacct'
  //},
  //'wme0008go': {
  //  field: 'wme0008acct',
  //  button: 'wme0008searchgacct'
  //},
  //'wme0008searchgacct': {
  //  field: 'wme0008acct',
  //  button: 'wme0008searchgacct'
  //},
  'wme0025go': {
    field: 'wme0025pacct',
    button: 'wme0025searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'wme0025searchgacct': {
  //  field: 'wme0025gacct',
  //  button: 'wme0025searchgacct'
  //},
  'wme0025searchpacct': {
    field: 'wme0025pacct',
    button: 'wme0025searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  'wme0155patsearch': {
    field: 'wme0155pacct',
    button: 'wme0155patsearch',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'wme11searchgacct': {
  //  field: 'wme11gacct',
  //  button: 'wme11searchgacct'
  //},
  'wme11searchpacct': {
    field: 'wme11pacct',
    button: 'wme11searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'wme185gacctgo': {
  //  field: 'wme185gacct',
  //  button: 'wme185searchgacct'
  //},
  'wme185pacctgo': {
    field: 'wme185pacct',
    button: 'wme185searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'wme185searchgacct': {
  //  field: 'wme185gacct',
  //  button: 'wme185searchgacct'
  //},
  'wme185searchpacct': {
    field: 'wme185pacct',
    button: 'wme185searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  'wme27go': {
    field: 'wme27ppacct',
    button: 'wme27searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  'wme27searchpacct': {
    field: 'wme27ppacct',
    button: 'wme27searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'wme36go': {
  //  field: 'wme36gacct',
  //  button: 'wme36searchgacct'
  //},
  //'wme36searchgacct': {
  //  field: 'wme36gacct',
  //  button: 'wme36searchgacct'
  //},
  //'wme42searchgacct': {
  //  field: 'wme42gacct',
  //  button: 'wme42searchgacct'
  //},
  'wme42searchpacct': {
    field: 'wme42pacct',
    button: 'wme42searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
  //'wme48searchgacct': {
  //  field: 'wme48gacct',
  //  button: 'wme48searchgacct'
  //},
  'wme48searchpacct': {
    field: 'wme48pacct',
    button: 'wme48searchpacct',
    skip: {wms0002: wms2skip},
    target: {wms0136: wms136apply}
  },
};

function on_blur(event) {
  console.debug('on-blur', event);
  var element =
    event.sender ? event.sender.element :
    $(event.target).closest('input, select, textarea');
  var kwin = element.closest('.k-window');
  if (!kwin.length)
    return;  // no kendo window means this was a login/2fa field, so skip it
  if (kwin.data('background'))
    return console.info(
      'window is in background', element.closest('.kendo-window')
    );
  var components = this.$root.$options.api.vm.components;
  var component = components[element.data('safe-id')];
  if (component && component.dirty)
    return on_field_change.call(this, event);
}

// TODO refactor into separate handlers for window, grid, narrative, and normal
function on_button_click(event) {
  console.debug('on_button_click', event);
  function kill() {
    event.preventDefault();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
    event.stopPropagation && event.stopPropagation();
  }
  var element =
    event.sender ? event.sender.element : $(event.target).closest('button');
  if (element.closest('.kendo-window').data('background'))
    return console.info(
      'window is in background', element.closest('.kendo-window')
    );
  var grid_id = element.data('grid');
  var id = element.data('send') || element.attr('id');
  if (element.data('narrative-button')) {
    var safeid = element.closest('[data-safe-id]').data('safe-id');
    var vm = this.$root.$options.api.vm;
    console.debug('previous value', vm.components[safeid].button_clicked);
    vm.$set(vm.components[safeid], 'button_clicked', id);
    return kill();
  }
  var data = {id: id};
  if (element.data('send-as-context-menu')) {
    data = {id: 'context-menu', value: id};
  } else if (grid_id) {
    var grid = $('#' + grid_id).data('kendo-grid');
    data = {id: grid_id, rows: this.$root.get_grid_selection(grid)};
  }
  var button = ACCT_BUTTONS[id];
  console.debug('buttons', id, button);
  if (button) {
    var form = button.form && element
      .closest('div.chi-form')
      .attr('class')
      .replace(/.*(w[am]e[^-]+)-form.*/, '$1');
    console.debug('buttons', form);
    if (!form && button.form === form) {
      var value = $('#' + button.field).val();
      console.debug('value', value);
      if (REGEXPS.IS_IT_TEXT.test(value)) {
        console.debug('register window_triggers', element, {
          config: button, data: {value: value}
        });
        this.$root.window_triggers.push({config: button, data: {value: value}});
        element = $('#' + (data.id = button.button));
        console.debug('element', element);
      }
    }
  }
  element.focus();
  setImmediate(function (self) {
    self.$root.$options.socket.emit('click', data);
  }, this);
  this.$root.$options.api.vm.active_control = element.attr('id');
  kill();
}

function on_calendar_change(event) {
  console.debug('on_calendar_change', event);
  var element = event.sender.element;
  var props = this.$root.get_props(element.data('safe-id'));
  var value = props.value = (event.sender.value() || '');
  if (value instanceof Date)
    value = dateformat(value, 'm/d/yyyy');
  this.$root.$options.socket.emit('change', {
    fullyear: props.fullyear, id: element.attr('id'), role: 'calendar',
    value: value,
  });
}

function on_context_menu_open(event) {
  console.debug('on_context_menu_open', this, event);
  var menu = event.sender;
  var grid = event.event && $(event.event.target).closest('.k-grid');
  if (grid && grid.length) {
    var added = GRID_CONTEXT_MENU.map(function (item) {
      return menu.dataSource.add(item);
    });
    menu.element.data('last-grid-id', grid.attr('id'));
    menu.one('close', function () {
      added.forEach(function (item) {menu.dataSource.remove(item)});
    });
  }
}

function on_enter_key(event) {
  console.debug('on_enter_key', this, event);
  this.$root.next_field(event.target || event.sender);
  event.preventDefault();
  event.stopImmediatePropagation();
}

function on_field_change(event) {
  console.debug('on_field_change', event);
  var vm = this.$root.$options.api.vm;
  var message = {};
  var element;
  var value;
  // kendo controls
  if (event.sender) {
    element = event.sender.element;
    value = event.sender.value() || '';
  // plain html controls
  } else {
    element = $(event.target);
    value = element.prop('value') || '';
  }
  var props = this.$root.get_props(element.data('safe-id'));
  var role = element.data('role') || element.attr('role');
  console.debug('on_field_change:', role, value, element, props);
  switch (role) {
  case 'checkbox':
    value = props[(element.prop('checked') ? '' : 'un') + 'checked_value'];
    break;
  case 'combobox':
    var kendo = event.sender || element.data('kendo-combo-box');
    // change fires for both the pretty input and the "real" input, but we only
    // want to react to the display input
    if (!kendo)
      return;
    // make sure the value entered is in the list of options
    var original = value;
    var options = kendo.dataSource.data();
    value = value.toLowerCase();
    var value_in_options = options.some(function (option) {
      if (value === option.value.toLowerCase()) {
        value = option.value;
        return true;
      }
    });
    if (!value_in_options) {
      kendo.value(original);
      return;
    }
    // if the list is visible, the user actually chose the item, as opposed to
    // the change event triggered when the user is arrowing through the list
    if (kendo.list.css('display') !== 'none')
      this.$root.next_field(element);
    break;
  case 'datepicker':
    kendo = event.sender || element.data('kendo-date-picker') || element.data('kendo-datepicker');
    // change fires for both the pretty input and the "real" input, but we only
    // want to react to the display input
    //if (!kendo)
    //  return;
    console.debug('on_field_change:', kendo);
    if (props && props.send_literals === false)
      value = value.replace(REGEXPS.SLASH, '');
    message.fullyear = props.fullyear;
    this.$root.next_field(element);
    break;
  case 'maskedtextbox':
    value = this.$root.demask(element, value);
    break;
  default:
    if (element.attr('type') === 'radio') {
      props = vm.components[element.closest('ul').data('safe-id')]; 
      role = 'radiobuttons';
      value = element.attr('value');
    } else {
      var maxlen = props && props.maxlength;
      if (maxlen !== undefined && value.length === maxlen)
        $(this.$root.next_field(element, true)).data('needs-select', true);
    }
  }
  if (element.length) {
    props = props || vm.components[element.data('safe-id')];
    props.value = value;
    props.dirty = false;
    if (typeof value === 'string') {
      value = value.replace(REGEXPS.NEWLINES, '\r\n');
    } else if (value instanceof Date) {
      value = dateformat(value, 'm/d/yyyy');
      if (props && props.send_literals === false)
        value = value.replace(REGEXPS.SLASH, '');
    }
    message.id = element.attr(role === 'radiobuttons' ? 'name' : 'id');
    message.role = role;
    message.value = value;
    this.$root.$options.socket.emit('change', message);
  }
}

function on_focus(event) {
  if (event.type === 'change')
    return;
  console.debug('on_focus', event);
  var target = event.sender ? event.sender.element : $(event.target);
  var id = target.attr('id');
  var role = target.attr('role');
  if (!id) {
    if (role === 'combobox')
      id = target.attr('aria-owns').replace('_listbox', '');
    else if (target.attr('type') === 'radio')
      id = target.attr('name');
  }
  if (id)
    this.$root.$options.api.vm.active_control = id;
  if (target.data('needs-select')) {
    target.removeData('needs-select');
    if (
      role === 'datepicker' || role === 'maskedtextbox' ||
      role === 'textfield' || role === 'textarea'
    )
      target[0].select();
  }
}

function on_grid_bound(event) {
  var self = this;
  var grid = event.sender;
  var $grid = grid.element;
  console.debug('on_grid_bound', this, event);
  if (!$grid.chi_mouse_events_bound)
    $(grid.tbody)
      .off('click.chi mousedown.chi mouseup.chi')
      .on('click.chi', function (event) {
        console.debug('grid-chi-click', this, event);
        grid.chi_mousedown_el = null;
        var target = event.target;
        if (target.nodeName !== 'TR' || target.nodeName !== 'TBODY') {
          var link = $(target)
            .closest('td')
            .find('a[data-href], a[id]')
            .get(0);
          if (link) {
            event.target = link;
            on_link_click.call(self, event, true);
            return false;
          }
        }
      })
      .on('mousedown.chi', function (event) {
        console.debug('grid-chi-mousedown', this, event);
        grid.chi_mousedown_el = event.target;
        grid.chi_dragged_click = null;
      })
      .on('mouseup.chi', function (event) {
        console.debug('grid-chi-mouseup', this, event);
        grid.chi_dragged_click = (event.target !== grid.chi_mousedown_el);
        grid.chi_mousedown_el = null;
      });
  if (!$grid.chi_ignore_next_bind) {
    var props = this.get_props($grid.data('safe-id'));
    if (props.enable_form_callback)
      props.enable_form_callback();
    Grid.add_options_menu(this, $grid, props);
  }
  $grid.chi_mouse_events_bound = true;
  $grid.chi_ignore_next_bind = false;
}

function on_grid_navigate(event) {
  console.debug('on_grid_navigate', this, event)
  var grid = event.sender;
  var $root = this.$root || window.vm;
  if ($root.$options.context_menu)
    $root.$options.context_menu.close();
  $root.$options.api.vm.active_control = grid.element.attr('id');
  grid.chi_dragged_click = null;
}

// If you want to listen for single and double clicks in DOM programming, you
// have to write your own. The end goal is the following behavior:
//  1. A "double-click" is two clicks on the same selection within 250ms.
//  2. If a grid is single-click-only, it emits a message on a new click and
//     ignores any following "double-click". It accepts new clicks 250ms after
//     the single-click.
//     For the time being, this is not an option.
//  3. If a grid is double-click-only, it does nothing on a new click, emits a
//     message on a "double-click", and ignores any following "triple-click".
//     It accepts new clicks 250ms after the double-click.
//     For the time being, this is not an option.
//  4. If a grid is both single- and double-click, it registers a new click. If
//     it receives a double-click, it emits the single-click message, then the
//     double-click message; if it does not receive a double-click within the
//     250ms window, it then emits the single-click message. It ignores any
//     following "triple-click". It accepts new clicks 250ms after the
//     double-click if received, or the single-click if not.
// Steps:
// (A)  Make sure the grid is actually selectable
// (B)  Get the selection and also stringify it to make it easy to compare it to
//      the previous click selection.
// (C)  Get the click type and either the previous click state, if it exists, or
//      a new click state.
// (D)  Define functions to clear all timeouts and to emit an event, which calls
//      the clear function and blocks all future click events for the next
//      250ms. and define callbacks for single and double click events.
// (E)  Decide how to handle the current event:
//      1. If this element can be double-clicked, and this is its first click
//         for the current selection, set a 250ms timeout to
//          a. trigger the single-click event, if the element can be single-
//             clicked as well as double-clicked, or
//          b. reset so that the next click is a new click
//      2. Otherwise--if the element is a single-click-only element, or it's the
//         second click on a double-click element--trigger the single- or
//         double-click callback.
function on_grid_select(event) {
  console.debug('on_grid_select', this, event);
  var $root = this.$root || window.vm;
  // (A)
  var grid = event.sender || event;
  var element = grid.element;
  if (!element || !element.jquery || !element.length)
    return console.error('on_grid_select: unexpected event object');
  var id = element.attr('id');
  var props = $root.get_props(element.data('safe-id'));
  grid.chi_dragged_click = null;
  //if (grid.chi_select_from_api)
  //  return grid.chi_select_from_api = null;
  if (element.data('api-grid-select'))
    return element.removeData('api-grid-select');
  if (!props.selectable)
    return;
  // flag grid as focused
  $root.$options.api.vm.active_control = id;
  // (B)
  var select_type = props.selectable.replace(REGEXPS.SELECTABLE, '$1s');
  var data = {id: id};
  var selection = $root.get_grid_selection(grid);
  grid.current_selector = selection.map(function (entry) {
    return 'tr:eq(' + (
      typeof entry === 'number' ? entry : entry[1] + ')>td:eq(' + entry[0]
    ) + ')';
  }).join(',');
  // (C)
  var onclick = element.data('onclick');
  onclick = onclick || {selection: selection, selector: grid.current_selector};
  if (onclick.selector !== grid.current_selector) {
    clear();
    onclick = {selection: selection, selector: grid.current_selector};
  } else if (onclick.blocked) {
    return;
  }
  // (D)
  function clear() {
    var timeout = onclick.blocked || onclick.timer;
    if (timeout) {
      clearTimeout(timeout);
      delete onclick.blocked;
      delete onclick.timer;
      delete onclick.callback;
    }
  }
  function select(data) {
    props['selected-' + select_type] = data[select_type] = selection;
    clear();
  }
  function emit(event, data) {
    if ($root.windows.peek().id === 'wcm0001')
      kendo.ui.progress($('#wcm0001').parent(), true);
    $root.$options.socket.emit(event, data);
    if (event === 'click')
      onclick.blocked = setTimeout(clear, 250);
  }
  // (E)
  function single() {
    select(data);
  }
  function double() {
    select(data);
    emit('click', data);
  }
  // (F)
  var td = grid._current;  // kendo internal property
  if (
    props.select_context_menu &&
    (props.any_cell_context || td.is(':last-of-type'))
  ) {
    $root.$options.api.events['set-menu']({
      ref: td, props: props, items: props.select_context_menu,
      timeout: Math.max(props.select_context_menu.length, 5) * 1000
    }, true);
    clear();
    onclick.blocked = setTimeout(clear, 250);
  } else if (onclick.timer || props.single_click_select) {
    if (props.single_click_select)
      element.closest('.k-window').data('windowing-delay', Date.now() + 300);
    double();
  } else {
    onclick.timer = setTimeout(single, 250);
    element.data('onclick', onclick);
  }
}

function on_keydown(event) {
  if (event.which === 115) {
    console.debug('on f4', this, event);
    event.preventDefault();
    return this.$options.socket.emit('f4', []);
  }
  if (event.altKey && event.which >= 0x41 && event.which <= 0x5a) {
    // key events send uppercase characters, so add 0x20 to make them lowercase
    var key = String.fromCharCode(event.which + 0x20);
    console.debug('on Alt+' + key, this, event);
    var target = this.$root.$options.api.vm.hotkeys.find(event.target, key);
    if (target) {
      event.preventDefault();
      target.focus();
      target.trigger('click');
    }
  }
}

function on_link_click(event, use_href_attr) {
  console.debug('on_link_click', this, event);
  var target = $(event.target).closest('a');
  if (target.length) {
    var send, href = target.data('href') || target.attr('href');
    if (REGEXPS.EXT_LINK.test(href)) {
      if (target.attr('target'))
        return;  // allow link click default action
      window.open(href);  // act like target="_blank"
    } else {
      if (use_href_attr)
        href.replace(REGEXPS.CHI_LINK, function (_, href) {send = href});
      if (send = send || target.attr('id'))
        this.$root.$options.socket.emit('click', {href: send});
    }
    event.preventDefault();
    event.stopPropagation();
  }
}

function on_masked_input(event) {
  console.debug('on_masked_input', this, event);
  var field = event.target;
  var $field = $(field);
  var kendo = $field.data('kendo-masked-text-box');
  var mask = kendo._emptyMask;
  var prompt = kendo.options.promptChar || '_';
  var plain = this.$root.demask(
    $field, field.value.replace(REGEXPS.TRAILING_UNDERSCORES, ''), false
  );
  for (var last, i = 0, j = 0, len = mask.length; i < len; ++i)
    if (mask.charAt(i) === prompt)
      last = plain.charAt(j++) || prompt;
  if (last !== prompt && $field.data('prev-last-char') === prompt)
    this.$root.next_field(field);
  $field.data('prev-last-char', last);
  $field.data('actual-change', true);
}

function on_menu_select(event) {
  console.debug('on_menu_select', event);
  var menu = event.sender ? event.sender.element : $();
  var item = $(event.item || event.target);
  if (event.type === 'click')
    item = item.closest('[id]');
  var id = item.attr('id');
  if (!event.sender) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  if (item.hasClass('header'))
    return;
  if (!id || id === 'b64:')
    return console.warn('No id attribute for element', event, item);
  if (id.startsWith('b64:'))
    id = atob(
      id.substring(4)
        .replace(REGEXPS.DASH, '+')
        .replace(REGEXPS.UNDERSCORE, '/')
    );
  if (id === 'jump-Help-wmf0438')
    return window.open(
      'https://ccc-webservices.com/static/teamviewer_client.exe', '_blank'
    );
  if (id === 'export-to-excel')
    return $('#' + menu.data('last-grid-id')).data('kendo-grid').saveAsExcel();
  if (id === 'export-to-pdf')
    return $('#' + menu.data('last-grid-id')).data('kendo-grid').saveAsPDF();
  if (id === 'grid-keys-reference')
    return;
  if (menu.data('send-as-click') || item.data('send-as-click'))
    this.$root.$options.socket.emit('click', {id: id});
  else
    this.$root.$options.socket.emit('click', {
      id: menu.data('role') === 'contextmenu' ? 'context-menu' : 'top-menu',
      value: id
    });
}

function on_paste(event) {
  console.debug('on_paste', this, event);
  var clipboard = event.clipboardData;
  if (!clipboard && event.originalEvent)
    clipboard = event.originalEvent.clipboardData;
  if (!clipboard)
    return console.error('could not find clipboard object');
  var data = clipboard.getData('text/plain');
  var valid = '';
  var changed; 
  for (var i = 0, len = Math.min(data.length, 30000), cc; i < len; ++i) {
    cc = data.charCodeAt(i);
    if (cc > 127 && cc < 256) {  // these code points are invalid in unicode
      valid += WIN1252_TO_UTF8[cc - 128];
      changed = true;
    } else {
      valid += data.charAt(i);
    }
    if (valid.length >= 30000)
      break;
  }
  if (changed || valid.length !== data.length) {
    var target = event.sender ? event.sender.element : $(event.target);
    var value = target.prop('value');
    var props = this.$options.api.vm.components[target.data('safe-id')];
    props.value = (
      value.substring(0, target.prop('selectionStart')) +
      valid + value.substring(target.prop('selectionEnd'))
    ).substring(0, +props.maxlength || 16000);
    this.$root.$options.socket.emit('change', {
      id: target.attr('id'),
      role: target.data('role') || target.attr('role'),
      value: props.value.replace(REGEXPS.NEWLINES, '\r\n')
    });
    event.preventDefault();
  }
}

function on_radio_click(event) {
  console.debug('on_radio_click', event);
  var element = event.sender ? event.sender.element : $(event.target);
  var kwindow = element.closest('.kendo-window');
  if (kwindow.data('background')) {
    console.info('window is in background', kwindow);
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}

function on_tab_activate(event) {
  console.debug('on_tab_activate', this, event);
  var tabstrip = event.sender;
  var active = this.$options.api.vm.active_control;
  var tab = $(event.contentElement);
  if (
    !active || active === tabstrip.element.attr('id') ||
    tabstrip.contentElements.not('.k-state-active').has('#' + active).length
  )
    this.apply_default_focus(tab);
  tab.attr('tabindex', '-1');
}

function on_tab_select(event) {
  console.debug('on_tab_select', this, event);
  var tabstrip = event.sender;
  var tab = $(event.item);
  // don't respond to select events that were triggered by an api select
  if (
    tabstrip.element.data('tab-load-ts') >= Date.now() - 300 ||
    tabstrip.element.data('api-select-ts') >= Date.now() - 100
  ) {
    console.debug(
      'ignoring select event triggered for default tab %s',
      tabstrip.element.attr('id')
    );
  } else {
    var tab_id = tabstrip.dataSource.at(tab.index()).id;
    // ignore select events on disabled or hidden tabs
    if (tab.data('hidden') || tab.data('disabled'))
      console.warn('ignoring select on hidden/disabled tab', tab_id);
    else
      this.$root.$options.api.queue_form_ops(
        this, 'on_tab_select', function (args, done) {
          this.$root.$options.socket.emit('click', args);
          done();
        }
      )({id: tabstrip.element.attr('id'), tab: tab_id});
  }
  tabstrip.element.removeAttr('data-tab-load-ts');
  //if (tabstrip.element.data('server_controlled'))
  //  event.preventDefault();
}


export default {
  on_blur: on_blur,
  on_button_click: on_button_click,
  on_calendar_change: on_calendar_change,
  on_context_menu_open: on_context_menu_open,
  on_enter_key: on_enter_key,
  on_field_change: on_field_change,
  on_focus: on_focus,
  on_grid_bound: on_grid_bound,
  on_grid_navigate: on_grid_navigate,
  on_grid_select: on_grid_select,
  on_keydown: on_keydown,
  on_link_click: on_link_click,
  on_masked_input: on_masked_input,
  on_menu_select: on_menu_select,
  on_paste: on_paste,
  on_radio_click: on_radio_click,
  on_tab_activate: on_tab_activate,
  on_tab_select: on_tab_select
};
